import store from './root-store';

export default store;
